function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#A0041E",
  d: "M9.344 14.702h-2c-.276 0-.5-.224-.5-.5v-7c0-.276.224-.5.5-.5h2c.276 0 .5.224.5.5v7c0 .276-.224.5-.5.5z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFE8B6",
  d: "M5 16L18 3l13 13v17H5z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCC4D",
  d: "M18 16h1v16h-1z"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#66757F",
  d: "M31 17c-.256 0-.512-.098-.707-.293L18 4.414 5.707 16.707c-.391.391-1.023.391-1.414 0s-.391-1.023 0-1.414l13-13c.391-.391 1.023-.391 1.414 0l13 13c.391.391.391 1.023 0 1.414-.195.195-.451.293-.707.293z"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#66757F",
  d: "M18 17c-.256 0-.512-.098-.707-.293-.391-.391-.391-1.023 0-1.414l6.5-6.5c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414l-6.5 6.5c-.195.195-.451.293-.707.293z"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1694F",
  d: "M10 26h4v6h-4z"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#55ACEE",
  d: "M10 17h4v4h-4zm12.5 0h4v4h-4zm0 9h4v4h-4z"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#5C913B",
  d: "M33.5 33.5c0 .828-.672 1.5-1.5 1.5H4c-.828 0-1.5-.672-1.5-1.5S3.172 32 4 32h28c.828 0 1.5.672 1.5 1.5z"
});
var SvgStoreIcon = function SvgStoreIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStoreIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/store-icon.deea117f.svg";
export { ForwardRef as ReactComponent };